import { render, staticRenderFns } from "./dettaglio.vue?vue&type=template&id=c7607cbc&"
import script from "./dettaglio.vue?vue&type=script&lang=js&"
export * from "./dettaglio.vue?vue&type=script&lang=js&"
import style0 from "./dettaglio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports